import { React, useState, useContext, useEffect } from "react";
import { FaChevronDown, FaChevronRight, FaEdit } from "react-icons/fa";
import { Col, Row, FormGroup, Label, Input, Form, Table, NavLink, } from "reactstrap";
import { useNavigate, useLocation } from "react-router-dom";
import SubHeader from "./SubHeader";
import { GlobalContext } from "../../App";
import TopHeader from "./TopHeader";
import { BsChevronRight } from "react-icons/bs";
import { toast } from "react-toastify";
import axios from "../../api/axios";
import Select from "react-select";
import { InfinitySpin } from "react-loader-spinner";
function AddBusinessUnit() {
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const [modal, setModal] = useState(false);
  const [isFilter, setIsFilter] = useState(false);
  const [buName, setBUName] = useState("");
  const [buDesc, setBUDesc] = useState("");
  const [isActive, setIsActive] = useState("1");
  const { rolexModuleData, roles, user_id } = useContext(GlobalContext);
  const [buData, setBUData] = useState("");
  const [updateId, setUpdateId] = useState("");
  const [companyId, setCompanyId] = useState("");
  const [companyList, setCompanyList] = useState("");
  const [productisOpen1, productsetIsOpen1] = useState(1);
  const [loading, setLoading] = useState(true); 
   // Handle Error
   const handleError = (error) => {
    setLoading(false);
    const statusCode = error.response ? error.response.status : null;
    let errorMessage = "An error occurred!";

    if (statusCode === 500) {
      errorMessage = "Internal Server Error!";
    } else if (statusCode === 404) {
      errorMessage = "Page Not Found!";
    }

    toast.error(errorMessage, {
      position: toast.POSITION.TOP_RIGHT,
      theme: "colored",
      autoClose: 2000,
    });
  };
  // ----------------------------------------------------------- Handle Close ---------------------------------------
  const handleClose = () => {
    setModal(false);
    setIsFilter(false);
    setBUName("");
    setBUDesc("");
    setUpdateId("");
    setIsActive("1");
    setCompanyId("");
  };
  // Modal State Change
  const toggleModal = () => {
    setIsFilter(false);
    setModal(!modal);
  };
  // Filter Data
  const toggleFilter = () => {
    setIsFilter(true);
    setModal(!modal);
  };
  // Post Company Data
  const postBUData = (e) => {
    e.preventDefault();
    if (buName === null || buName === "") {
      toast.error("Business Unit Name is required!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    } else if (buDesc === null || buDesc === "") {
      toast.error("Business Unit Description is required!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    } else {
      const params = {
        companyId: companyId,
        BUName: buName,
        BUDesc: buDesc,
        isActive: isActive,
        user_id: user_id,
        updateId: updateId,
      };
      axios
        .post("/postBUData", params)
        .then((response) => {
          if (response?.status === 202) {
            toast.error("Business Unit Name Already Exist!", {
              position: toast.POSITION.TOP_RIGHT,
              theme: "colored",
              autoClose: 2000,
            });
          } else {
            toast.success("Business Unit Insert/Updated Successfully!", {
              position: toast.POSITION.TOP_RIGHT,
              theme: "colored",
              autoClose: 2000,
            });
            handleClose();
            getCompBuDeptData();
          }
        })
        .catch(handleError);
    }
  };
  // get Company Data
  const getCompBuDeptData = () => {
    setLoading(true);
    axios
      .get("/getCompBuDeptData")
      .then((response) => {
        setBUData(response?.data?.[0]?.company_data);
        const companyList =
          response?.data?.[0]?.company_data?.map((item) => ({
            label: item?.company_name,
            value: item?.company_id,
          })) ?? [];
        setCompanyList(companyList);
        setLoading(false);
      })
      .catch(handleError);
  };
  // Company Update
  const buUpt = (company_id, bu_id) => {
    const companyData = buData?.find(
      (data) => data?.company_id === company_id
    )?.bu_data;
    const buItem = companyData?.find((item) => item?.bu_id === bu_id);
    if (buItem) {
      setBUName(buItem.bu_name);
      setBUDesc(buItem.bu_description);
      setIsActive(buItem.isActive);
      setUpdateId(bu_id);
      setCompanyId({
        label: buData?.find((data) => data?.company_id === company_id)
          ?.company_name,
        value: company_id,
      });
      setModal(true);
    }
  };

  // -------------------------------------------------------- Use Effect -----------------------------------------
  useEffect(() => {
    getCompBuDeptData();
  }, []);
  const businessUnitContent = (
    <Form name="personal-info-details" className="modelform">
      <Row>
        <Col md={12}>
          <FormGroup>
            <Label htmlFor="companyName">Company Name*</Label>
            <Select
              classNamePrefix="react-select"
              className="multi-select"
              menuPlacement="auto"
              maxMenuHeight={200}
              onChange={(select) => setCompanyId(select)}
              options={companyList}
              value={companyId || ""}
              isDisabled={updateId}
              // {...props}
              theme={(theme) => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  primary25: "rgba(2, 137, 255,.2)",
                  primary50: "rgba(2, 137, 255,.2)",
                  primary75: "rgba(2, 137, 255,.2)",
                  primary: "#0289ff",
                },
              })}
            />
          </FormGroup>
        </Col>
        <Col md={12}>
          <FormGroup>
            <Label htmlFor="businessUnitName">Business Unit Name*</Label>
            <Input
              id="businessUnitName"
              name="businessUnitName"
              type="text"
              value={buName}
              placeholder="Business Unit Name "
              onChange={(e) => setBUName(e.target.value)}
            />
          </FormGroup>
        </Col>
        <Col md={12}>
          <FormGroup>
            <Label htmlFor="role_desc">Description*</Label>
            <Input
              id="roleDesc"
              name="roleDesc"
              type="textarea"
              value={buDesc}
              placeholder="Description"
              onChange={(e) => setBUDesc(e.target.value)}
            />
          </FormGroup>
        </Col>

        <Col md={12}>
          <FormGroup>
            <Label htmlFor="role_desc">Status:</Label>
            <div>
              <div className="d-inline-block m-2">
                <input
                  type="radio"
                  id="isActive"
                  name="status"
                  value="1"
                  checked={isActive === "1" ? true : false}
                  onChange={(e) => setIsActive("1")}
                />{" "}
                Active
              </div>
              <div className="d-inline-block">
                <input
                  type="radio"
                  id="isInactive"
                  name="status"
                  value="0"
                  checked={isActive === "1" ? false : true}
                  onChange={(e) => setIsActive("0")}
                />{" "}
                Inactive
              </div>
            </div>
          </FormGroup>
        </Col>
      </Row>
    </Form>
  );
  return (
    loading ? (
      <div className="loader">
      <InfinitySpin width="200" color="#D81159" />
    </div>
    ) :
    (<>
      <TopHeader
        breadCrumb={
          <>
            <li className="nav-item">
              <a onClick={() => navigate("/home")} className="nav-link">
                Home <BsChevronRight />
              </a>
            </li>
            <li className="nav-item">
              <span>Add Business Unit</span>
            </li>
          </>
        }
      />
      <SubHeader
        SubHeaderTitle="Add Business Unit"
        openSidebar={modal}
        isFilter={isFilter}
        handleClose={handleClose}
        toggleModal={toggleModal}
        toggleFilter={toggleFilter}
        handleSubmit={postBUData}
        titleButton={`${updateId ? "Edit" : "Add"} Business Unit`}
        showButton={((rolexModuleData?.find((data) => pathname === data?.description && data?.create === 1)) || roles?.find((data) => data?.role_id === 1001)) ? true : false}
        AddUserContent={businessUnitContent}
      />
      <div className="bu-wrap">
        <div className="managerole-wrap contentInnerWrap">
          {buData?.length > 0 ? (
            buData
              ?.filter((item) => item?.bu_data)
              ?.map((item) => (
                <div className="managerole">               
                  <div className="dropdown" onClick={() => productsetIsOpen1(productisOpen1 === item?.company_id ? 0 : item?.company_id )}>
                    {productisOpen1 === item?.company_id ? (
                      <FaChevronDown  />
                    ) : (
                      <FaChevronRight />
                    )}
                    <span>{item?.company_name}</span>
                  </div>
                  <div className="manage-table">
                    <div
                      className={
                        productisOpen1 === item?.company_id
                          ? "product-list  productlist-open"
                          : "product-list "
                      }
                    >
                      <Table striped responsive>
                        <thead>
                          <tr>
                            <th style={{ width: "3" }}>Business Unit ID</th>
                            <th>Business Unit Name</th>
                            <th> Description</th>
                            <th>Status</th>
                            <th>Created on</th>
                            <th>Updated on</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {item?.bu_data?.map((data) => (
                            <tr>
                              <th scope="row">{data?.bu_id}</th>
                              <td>{data?.bu_name}</td>
                              <td>{data?.bu_description}</td>
                              <td>
                                {data?.isActive === "1" ? "Active" : "Inactive"}
                              </td>
                              <td>
                                {new Date(
                                  data?.createdDate?.split("T")?.[0]
                                )?.toLocaleDateString("en-GB", {
                                  day: "numeric",
                                  month: "numeric",
                                  year: "numeric",
                                })}
                              </td>
                              <td>
                                {new Date(
                                  data?.updatedDate?.split("T")?.[0]
                                )?.toLocaleDateString("en-GB", {
                                  day: "numeric",
                                  month: "numeric",
                                  year: "numeric",
                                })}
                              </td>
                              <td>
                                {((rolexModuleData?.find((data) => pathname === data?.description && data?.update === 1)) || roles?.find((data) => data?.role_id === 1001)) ? <NavLink className="edit" onClick={() => buUpt(data?.company_id, data?.bu_id) } > <FaEdit /> </NavLink> :  '-'}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
              ))
          ) : (
            <div className="emptydata">
              <p>There is no company data!</p>
            </div>
          )}
        </div>
      </div>
    </>)
  );
}

export default AddBusinessUnit;
